import i18n from '@/helper/i18n';

export default function formatTimePeriods(value) {
  return i18n.te(`timePeriodOptions.${value}`)
    ? i18n.t(`timePeriodOptions.${value}`)
    : i18n.t(`dueDatePeriodOptions.${value}`)
    ? i18n.t(`dueDatePeriodOptions.${value}`)
    : value;
}
